/** The backend's longest cadence (jobs::fleet::MAX_INTERVAL_SECS). The shortest is per piece of work. */
export const MAX_INTERVAL_SECS = 7 * 24 * 60 * 60

/**
 * Hours as typed, as a cadence in seconds, or `undefined` if it isn't one the
 * backend accepts for work whose shortest cadence is `minSecs`.
 */
export function hoursToIntervalSecs(hours: string, minSecs: number): number | undefined {
    if (hours.trim() === '') {
        return undefined
    }
    const secs = Math.round(Number(hours) * 3600)
    if (!Number.isFinite(secs) || secs < minSecs || secs > MAX_INTERVAL_SECS) {
        return undefined
    }
    return secs
}

/** "6 hours", "1 hour", "30 minutes". */
export function durationText(secs: number): string {
    if (secs % 3600 === 0) {
        const hours = secs / 3600
        return hours === 1 ? '1 hour' : `${hours} hours`
    }
    return `${Math.round(secs / 60)} minutes`
}

/** "every 6 hours", "every 30 minutes". */
export function cadenceText(intervalSecs: number): string {
    return intervalSecs === 3600 ? 'every hour' : `every ${durationText(intervalSecs)}`
}

/** "Between 1 hour and 7 days." */
export function rangeText(minSecs: number): string {
    return `Between ${durationText(minSecs)} and ${MAX_INTERVAL_SECS / 86400} days.`
}
